import type {ButtonProps} from '@/components/common/Button';

export const colorVariants: Record<
  NonNullable<ButtonProps['colorScheme']>,
  {solid: string; outline: string}
> = {
  indigo: {
    solid:
      'py-2 px-4 bg-indigo-600 hover:bg-indigo-400 active:bg-indigo-600 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-indigo-700  border border-indigo-600 hover:bg-indigo-600 active:text-white active:bg-indigo-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
  cyan: {
    solid:
      'py-2 px-4 bg-cyan-700 hover:bg-cyan-400 active:bg-cyan-700 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-cyan-700  border border-cyan-600 hover:bg-cyan-600 active:text-white active:bg-cyan-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
  red: {
    solid:
      'py-2 px-4 bg-red-600 hover:bg-red-400 active:bg-red-600 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-red-700 border border-red-600 hover:bg-red-600 active:text-white active:bg-red-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
  green: {
    solid:
      'py-2 px-4 bg-green-600 hover:bg-green-400 active:bg-green-600 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-green-700  border border-green-600 hover:bg-green-600 active:text-white active:bg-green-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
  yellow: {
    solid:
      'py-2 px-4 bg-yellow-600 hover:bg-yellow-400 active:bg-yellow-600 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-yellow-700 border border-yellow-600 hover:bg-yellow-600 active:text-white active:bg-yellow-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
  orange: {
    solid:
      'py-2 px-4 bg-orange-600 hover:bg-orange-400 active:bg-orange-600 text-white font-medium transition-all ease-in-out duration-300 text-sm',
    outline:
      'bg-none py-2 px-4 text-orange-700 border border-orange-600 hover:bg-orange-600 active:text-white active:bg-orange-1000 hover:text-white transition-all ease-in-out duration-300 text-sm',
  },
};

export type ButtonColorScheme =
  'cyan' | 'indigo' | 'red' | 'green' | 'yellow' | 'orange';

export const baseClasses = {
  unStyled:
    'bg-none color-inherit border-none p-0 font-inherit outline-none text-sm',
  ghost:
    'bg-none color-inherit text-cyan-700 py-2 px-4 active:bg-indigo-200 transition-all ease-in-out duration-300 text-sm',
  disabled:
    'py-2 px-4 disabled:opacity-50 disabled:text-slate-300 disabled:bg-gray-100 disabled:text-gray-400 text-sm transition-all ease-in-out duration-300',
};
